define('webshopAttributesCategoryView',[
  'module',
  'app',
  'backbone',
  'marionette',
  'underscore',
  'modalsAlertView',
  'modalsConfirmationView',
  'webshopCategorySelectView',
  'webshopAttributesProductInfoView',
  'entities/webshop/attribute_matching',
  'template!webshopAttributesCategoryView'
], function (
  Module,
  App,
  Backbone,
  Marionette,
  _,
  AlertView,
  ConfirmationView,
  CategorySelectView,
  ProductInfoView,
  MatchingApi,
  Tpl
) {
  'use strict';

  var PAGE_SIZE = 50;
  var ASSIGN_CHUNK = 200;

  // The products of a webshop category with their canonical values (supplier ones from the PIM
  // import, manual ones from the reseller attributes), and the manual assignment of values of an
  // attribute to selected products or to the whole category. Manual values live in the PIM
  // (reseller attributes): they survive the syncs and reach the webshop through the filters webhook.
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-attributes-category-view',

    regions: {
      categoryRegion: '.category-region'
    },

    ui: {
      key: 'select.key',
      values: '.values',
      list: '.rows',
      pager: '.am-pager',
      scopeAll: 'input.scope-all',
      selectedCount: '.selected-count',
      checkAll: 'input.check-all',
      categoryInfo: '.category-info',
      actions: '.actions'
    },

    events: {
      'change @ui.key': 'onKeyChange',
      'click .value-chip': 'onToggleValue',
      'change input.check': 'onCheck',
      'change @ui.checkAll': 'onCheckAll',
      'change @ui.scopeAll': 'renderSelected',
      'click .action': 'onAction',
      'click .am-chip .remove': 'onRemoveChip',
      'click .product-info': 'onProductInfo',
      'change input.hide-outdated, input.hide-disabled': 'onHideChange',
      'change input.with-subcategories': 'onSubcategoriesChange',
      'input input.product-search': 'onSearch',
      'click .prev': 'onPrev',
      'click .next': 'onNext'
    },

    initialize: function () {
      this.category = null;
      this.keys = [];
      this.keyValues = {};
      this.selectedValues = {};
      this.first = 0;
      this.total = 0;
      this.products = [];
      this.productValues = {};
      this.checked = {};
      this.allProducts = [];
      this.query = '';
      this.hide = ProductInfoView.Helper.hideOptions();
    },

    serializeData: function () {
      if (this.withSub === undefined)
        this.withSub = (this.options.state || {}).sub === '1';
      return {hideHtml: ProductInfoView.Helper.hideHtml(this.hide), legendHtml: ProductInfoView.Helper.legendHtml(),
        subHtml: ProductInfoView.Helper.subHtml(this.withSub)};
    },

    onSubcategoriesChange: function () {
      this.withSub = this.$('input.with-subcategories').is(':checked');
      this.setState({sub: this.withSub ? '1' : null});
      this.first = 0;
      this.checked = {};
      this.fetchProducts();
    },

    onShow: function () {
      // State of the URL: category, attribute, search
      var state = this.options.state || {};
      if (state.cat)
        this.category = {id: state.cat, code: state.catCode || ''};
      this.query = state.q || '';
      this.$('input.product-search').val(this.query);

      this.getRegion('categoryRegion').show(new CategorySelectView({
        model: new Backbone.Model({id: this.category ? this.category.id : '', code: this.category ? this.category.code : ''}),
        onChange: _.bind(function (model) {
          this.category = model.get('id') ? {id: model.get('id'), code: model.get('code')} : null;
          this.first = 0;
          this.checked = {};
          this.setState({cat: this.category ? this.category.id : null, catCode: this.category ? this.category.code : null});
          this.fetchProducts();
          return $.Deferred().resolve().promise();
        }, this)
      }));

      this.ui.key.prop('disabled', true);
      MatchingApi.keys().done(_.bind(function (keys) {
        this.keys = _.sortBy(keys, function (k) { return MatchingApi.name(k).toLowerCase(); });
        if (this.isDestroyed)
          return;
        this.ui.key.html('<option value="">' + _.escape(_.i18n('attributeMatching.allAttributes', null, 'All attributes')) + '</option>' +
          _.map(this.keys, function (k) {
            return '<option value="' + k.id + '">' + _.escape(MatchingApi.name(k)) + (k.showInFilters ? '' : ' ' + _.escape(_.i18n('attributeMatching.notFilterSuffix', null, '(not a filter)'))) + '</option>';
          }).join(''));
        this.ui.key.prop('disabled', false);
        if (state.key && _.findWhere(this.keys, {id: parseInt(state.key, 10)})) {
          this.ui.key.val(String(state.key));
          this.renderValues();
          this.renderRows();
        }
        // Values of every attribute, to name the chips.
        _.each(this.keys, function (k) { this.fetchValues(k.id); }, this);
      }, this)).fail(_.bind(this.showError, this));

      this.renderValues();
      this.renderSelected();
      if (this.category)
        this.fetchProducts();
    },

    setState: function (changes) {
      if (this.options.onState)
        this.options.onState(changes);
    },

    selectedKeyId: function () {
      return this.ui.key.val() ? parseInt(this.ui.key.val(), 10) : null;
    },

    fetchValues: function (keyId) {
      if (this.keyValues[keyId])
        return $.Deferred().resolve(this.keyValues[keyId]).promise();
      return MatchingApi.values(keyId).done(_.bind(function (values) {
        this.keyValues[keyId] = _.sortBy(values, function (v) { return MatchingApi.name(v).toLowerCase(); });
        if (!this.isDestroyed) {
          if (keyId === this.selectedKeyId())
            this.renderValues();
          this.renderRows();
        }
      }, this));
    },

    onKeyChange: function () {
      this.setState({key: this.selectedKeyId()});
      this.selectedValues = {};
      this.renderValues();
      this.renderRows();
      this.renderSelected();
    },

    renderValues: function () {
      var keyId = this.selectedKeyId();
      if (!keyId) {
        this.ui.values.html('<span class="am-hint">' + _.i18n('attributeMatching.pickAttribute', null, 'Pick an attribute to assign its values') + '</span>');
        return;
      }
      var values = this.keyValues[keyId] || [];
      var labels = MatchingApi.labels(values);
      this.ui.values.html(_.map(values, function (v) {
        var color = MatchingApi.color(v);
        return '<span class="value-chip ' + (this.selectedValues[v.id] ? 'on' : '') + '" data-id="' + v.id + '">' +
          (color ? '<span class="am-swatch" style="background:' + _.escape(color) + '"></span>' : '') +
          _.escape(labels[v.id]) + '</span>';
      }, this).join('') || '<span class="am-hint">' + _.i18n('attributeMatching.noValue', null, 'No value yet') + '</span>');
    },

    onToggleValue: function (e) {
      var id = parseInt($(e.currentTarget).data('id'), 10);
      if (this.selectedValues[id])
        delete this.selectedValues[id];
      else
        this.selectedValues[id] = true;
      $(e.currentTarget).toggleClass('on', !!this.selectedValues[id]);
      this.renderSelected();
    },

    //----------------
    // Products

    // The whole category is loaded once (its products, not their values): hiding outdated /
    // disabled products and "Whole category" work on the visible ones, paged here.
    fetchProducts: function () {
      this.products = [];
      this.allProducts = [];
      this.visibleProducts = [];
      this.productValues = {};
      this.total = 0;
      this.first = 0;
      if (!this.category) {
        this.renderRows();
        return;
      }
      var category = this.category;
      this.renderRows();
      this.loading(true);
      $.ajax({
        type: 'GET',
        url: App.request('webshop.category.products.count', category.id, ProductInfoView.Helper.productParams(this.withSub)),
        success: _.bind(function (count) {
          if (category !== this.category)
            return;
          this.loadCodes(category, 0, Math.max(parseInt(count, 10) || 0, 1)).done(_.bind(function (products) {
            if (this.isDestroyed || category !== this.category)
              return;
            this.allProducts = products;
            this.loading(false);
            this.applyHide();
          }, this)).fail(_.bind(function () {
            this.loading(false);
          }, this));
        }, this),
        error: _.bind(function () {
          this.loading(false);
          this.showError(_.i18n('attributeMatching.categoryError', null, 'The products of the category could not be loaded'));
        }, this)
      });
    },

    // Visible products: hide options, then the search.
    applyHide: function () {
      var query = this.query;
      this.visibleProducts = _.filter(ProductInfoView.Helper.visible(this.allProducts, this.hide), function (p) {
        return ProductInfoView.Helper.matches(p, query);
      });
      var visible = _.object(_.pluck(this.visibleProducts, 'code'), _.map(this.visibleProducts, function () { return true; }));
      _.each(_.keys(this.checked), function (code) {
        if (!visible[code])
          delete this.checked[code];
      }, this);
      this.total = this.visibleProducts.length;
      this.first = Math.min(this.first, Math.max(0, this.total - 1));
      this.first -= this.first % PAGE_SIZE;
      this.fetchPage();
    },

    fetchPage: function () {
      this.products = (this.visibleProducts || []).slice(this.first, this.first + PAGE_SIZE);
      this.renderRows();
      var missing = _.reject(_.pluck(this.products, 'code'), function (code) { return this.productValues[code]; }, this);
      this.fetchProductValues(missing);
    },

    onSearch: function () {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(_.bind(function () {
        this.query = this.$('input.product-search').val() || '';
        this.first = 0;
        this.setState({q: this.query});
        this.applyHide();
      }, this), 250);
    },

    onHideChange: function () {
      this.hide = {outdated: this.$('input.hide-outdated').is(':checked'), disabled: this.$('input.hide-disabled').is(':checked')};
      ProductInfoView.Helper.setHideOptions(this.hide);
      this.applyHide();
    },

    loadCodes: function (category, first, pageSize) {
      var defer = $.Deferred();
      $.ajax({
        type: 'GET',
        url: App.request('webshop.category.products', category.id, ProductInfoView.Helper.productParams(this.withSub, {first: first, pageSize: pageSize})),
        success: function (products) {
          defer.resolve(_.map(products, ProductInfoView.Helper.wrap));
        },
        error: _.bind(function () {
          this.showError(_.i18n('attributeMatching.categoryError', null, 'The products of the category could not be loaded'));
          defer.reject();
        }, this)
      });
      return defer.promise();
    },

    fetchProductValues: function (codes) {
      if (!codes.length)
        return;
      this.loading(true);
      MatchingApi.productValues(codes).done(_.bind(function (result) {
        _.each(result, function (pv) {
          this.productValues[pv.productCode] = pv;
        }, this);
        if (!this.isDestroyed)
          this.renderRows();
      }, this)).fail(_.bind(this.showError, this)).always(_.bind(function () {
        this.loading(false);
      }, this));
    },

    // Spinner over the products while they (or their values) load.
    loading: function (on) {
      if (!this.isDestroyed)
        this.$('.table').toggleClass('am-loading', on);
    },

    valueName: function (keyId, valueId) {
      var label = MatchingApi.labels(this.keyValues[keyId] || [])[valueId];
      return label || '#' + valueId;
    },

    chips: function (pv, keyId) {
      var values = _.filter(pv.values, function (v) { return !keyId || v.keyId === keyId; });
      var byKey = _.groupBy(values, 'keyId');
      return _.map(byKey, function (vals, kId) {
        kId = parseInt(kId, 10);
        var key = _.findWhere(this.keys, {id: kId});
        return '<div class="key-values">' + (keyId ? '' : '<span class="key-name">' + _.escape(key ? MatchingApi.name(key) : '#' + kId) + '</span>') +
          _.map(vals, function (v) {
            var value = _.findWhere(this.keyValues[kId] || [], {id: v.valueKeyId});
            var color = MatchingApi.color(value);
            var manual = v.source === 'MANUAL';
            return '<span class="am-chip ' + (manual ? 'manual' : '') + (v.filter ? '' : ' no-filter') + '" ' +
              'title="' + _.escape(manual ? _.i18n('attributeMatching.manualValue', null, 'Manual value') :
                _.i18n('attributeMatching.supplierValueChip', null, 'Supplier value (PIM import)')) +
              (v.filter ? '' : ' — ' + _.escape(_.i18n('attributeMatching.notInFilter', null, 'not a filter value'))) + '">' +
              (color ? '<span class="swatch" style="background:' + _.escape(color) + '"></span>' : '') +
              _.escape(this.valueName(kId, v.valueKeyId)) +
              (manual ? '<span class="remove" data-key="' + kId + '" data-value="' + v.valueKeyId + '"><i class="fa fa-times"></i></span>' : '') +
              '</span>';
          }, this).join(' ') + '</div>';
      }, this).join('');
    },

    renderRows: function () {
      if (!this.category) {
        this.ui.list.html('<div class="empty">' + _.i18n('attributeMatching.pickCategory', null, 'Pick a webshop category') + '</div>');
        this.renderPager();
        return;
      }
      var keyId = this.selectedKeyId();
      var html = _.map(this.products, function (p) {
        var pv = this.productValues[p.code];
        var values = '';
        if (!pv)
          values = '<span class="am-hint">…</span>';
        else if (!pv.found)
          values = '<span class="am-hint">' + _.i18n('attributeMatching.noPimProduct', null, 'No PIM sheet: values cannot be assigned') + '</span>';
        else
          values = this.chips(pv, keyId) || '<span class="am-hint">—</span>';
        return '<div class="row" data-code="' + _.escape(p.code) + '">' +
          '<div class="col-check"><input type="checkbox" class="check" ' + (this.checked[p.code] ? 'checked' : '') +
          (pv && !pv.found ? ' disabled' : '') + '/></div>' +
          '<div class="col-product product-cell">' + ProductInfoView.Helper.cellHtml(p) + '</div>' +
          '<div class="col-values">' + values + '</div>' +
          '</div>';
      }, this).join('');
      this.ui.list.html(html || '<div class="empty">' + _.i18n('attributeMatching.emptyCategory', null, 'No product in this category') + '</div>');
      this.ui.checkAll.prop('checked', false);
      this.renderPager();
    },

    renderPager: function () {
      var last = Math.min(this.first + PAGE_SIZE, this.total);
      this.ui.pager.html(
        '<span class="prev ' + (this.first > 0 ? '' : 'off') + '"><i class="fa fa-chevron-left"></i></span>' +
        '<span>' + (this.total ? this.first + 1 : 0) + '–' + last + ' / ' + this.total + '</span>' +
        '<span class="next ' + (last < this.total ? '' : 'off') + '"><i class="fa fa-chevron-right"></i></span>');
      this.ui.categoryInfo.text(!this.category ? '' : this.total === this.allProducts.length ?
        this.total + ' ' + _.i18n('common.products', null, 'products') :
        this.total + ' / ' + this.allProducts.length + ' ' + _.i18n('common.products', null, 'products'));
      this.renderSelected();
    },

    onPrev: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first = Math.max(0, this.first - PAGE_SIZE);
      this.fetchPage();
    },

    onNext: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first += PAGE_SIZE;
      this.fetchPage();
    },

    //----------------
    // Selection / assignment

    onCheck: function (e) {
      var code = $(e.currentTarget).closest('.row').attr('data-code');
      if ($(e.currentTarget).is(':checked'))
        this.checked[code] = true;
      else
        delete this.checked[code];
      this.renderSelected();
    },

    onCheckAll: function () {
      var on = this.ui.checkAll.is(':checked');
      _.each(this.products, function (p) {
        var pv = this.productValues[p.code];
        if (on && (!pv || pv.found))
          this.checked[p.code] = true;
        else
          delete this.checked[p.code];
      }, this);
      this.$('input.check:not(:disabled)').prop('checked', on);
      this.renderSelected();
    },

    renderSelected: function () {
      var all = this.ui.scopeAll.is(':checked');
      this.ui.selectedCount.text(all ? this.total : _.keys(this.checked).length);
      var ready = !!this.selectedKeyId() && (all ? this.total > 0 : _.keys(this.checked).length > 0);
      this.ui.actions.toggleClass('off', !ready);
    },

    onAction: function (e) {
      var mode = $(e.currentTarget).data('mode');
      var keyId = this.selectedKeyId();
      var valueIds = _.map(_.keys(this.selectedValues), function (id) { return parseInt(id, 10); });
      if (!keyId)
        return;
      if (!valueIds.length && mode !== 'REPLACE') {
        this.showError(_.i18n('attributeMatching.pickValues', null, 'Select at least one value'));
        return;
      }
      var all = this.ui.scopeAll.is(':checked');
      var count = all ? this.total : _.keys(this.checked).length;
      var key = _.findWhere(this.keys, {id: keyId});
      var names = _.map(valueIds, function (id) { return this.valueName(keyId, id); }, this).join(', ') ||
        _.i18n('attributeMatching.noValueLabel', null, '(none)');
      var text = {
        ADD: _.i18n('attributeMatching.confirmAdd', null, 'Add %v to "%k" on %n products?'),
        REMOVE: _.i18n('attributeMatching.confirmRemove', null, 'Remove the manual values %v of "%k" from %n products?'),
        REPLACE: _.i18n('attributeMatching.confirmReplace', null, 'The manual values of "%k" become %v on %n products. Continue?')
      }[mode].replace('%v', names).replace('%k', MatchingApi.name(key)).replace('%n', count);

      ConfirmationView.prototype.open({
        text: text,
        onConfirm: _.bind(function () {
          var codes = all ? null : _.keys(this.checked);
          this.runAssignment(codes, keyId, valueIds, mode);
        }, this)
      });
    },

    // codes null: every product of the category (loaded page by page).
    runAssignment: function (codes, keyId, valueIds, mode) {
      var getCodes = $.Deferred().resolve(codes || _.pluck(this.visibleProducts, 'code')).promise();

      this.ui.actions.addClass('busy');
      getCodes.done(_.bind(function (allCodes) {
        var chunks = [];
        for (var i = 0; i < allCodes.length; i += ASSIGN_CHUNK)
          chunks.push(allCodes.slice(i, i + ASSIGN_CHUNK));

        var totals = {updated: 0, unchanged: 0, notFound: [], failed: {}, webshopErrors: {}};
        var next = _.bind(function (index) {
          if (index >= chunks.length) {
            this.assignmentDone(totals);
            return;
          }
          this.ui.selectedCount.text((index * ASSIGN_CHUNK) + ' / ' + allCodes.length);
          MatchingApi.assign(chunks[index], keyId, valueIds, mode).done(function (result) {
            totals.updated += result.updated.length;
            totals.unchanged += result.unchanged.length;
            totals.notFound = totals.notFound.concat(result.notFound);
            _.extend(totals.failed, result.failed);
            _.extend(totals.webshopErrors, result.webshopErrors);
            next(index + 1);
          }).fail(_.bind(function (message) {
            this.ui.actions.removeClass('busy');
            this.showError(message);
            this.productValues = {};
            this.fetchPage();
          }, this));
        }, this);
        next(0);
      }, this)).fail(_.bind(function () {
        this.ui.actions.removeClass('busy');
      }, this));
    },

    assignmentDone: function (totals) {
      this.ui.actions.removeClass('busy');
      this.checked = {};
      var text = _.i18n('attributeMatching.assignDone', null, '%u products updated, %s unchanged.')
        .replace('%u', totals.updated).replace('%s', totals.unchanged);
      if (totals.notFound.length)
        text += ' ' + _.i18n('attributeMatching.assignNotFound', null, 'Without PIM sheet: %l.').replace('%l', totals.notFound.join(', '));
      if (_.keys(totals.failed).length)
        text += ' ' + _.i18n('attributeMatching.assignFailed', null, 'Failed: %l.')
          .replace('%l', _.map(totals.failed, function (m, c) { return c + ' (' + m + ')'; }).join(', '));
      if (_.keys(totals.webshopErrors).length)
        text += ' ' + _.i18n('attributeMatching.assignNotSynced', null, 'Not sent to the webshop: %l.')
          .replace('%l', _.map(totals.webshopErrors, function (m, c) { return c + ' (' + m + ')'; }).join(', '));
      AlertView.prototype.open('', text);
      // Values changed: reload them (page by page, as the products are shown)
      this.productValues = {};
      this.fetchPage();
    },

    onProductInfo: function (e) {
      e.stopPropagation();
      var code = $(e.currentTarget).closest('.row').attr('data-code');
      var product = _.findWhere(this.products, {code: code});
      if (product)
        ProductInfoView.Helper.open(product);
    },

    onRemoveChip: function (e) {
      e.stopPropagation();
      var code = $(e.currentTarget).closest('.row').attr('data-code');
      var keyId = parseInt($(e.currentTarget).data('key'), 10);
      var valueId = parseInt($(e.currentTarget).data('value'), 10);
      MatchingApi.assign([String(code)], keyId, [valueId], 'REMOVE').done(_.bind(function (result) {
        if (result.webshopErrors && _.keys(result.webshopErrors).length)
          this.showError(_.i18n('attributeMatching.webshopNotSynced', null, 'Saved, but not sent to the webshop: %s')
            .replace('%s', _.values(result.webshopErrors).join(', ')));
        this.fetchProductValues([String(code)]);
      }, this)).fail(_.bind(this.showError, this));
    },

    showError: function (message) {
      AlertView.prototype.open('', message);
    }
  });
});

